<template>
  <div class="cart-total">
    <h2 class="cart__total--mobile">
      {{ $t("payment.total") }}
      <span>{{ formattedPrice(cartTotalCost) }}</span>
    </h2>
    <div class="cart__total--desktop">
      <h2 class="cart-total__title">{{ $t('payment.order_summary') }}</h2>
      <ul class="cart-summary">
        <li class="cart-summary__item">
          <span class="cart-summary__label">{{ $t('payment.subtotal') }}</span>
          <span class="cart-summary__value">{{ formattedPrice(cart.cartSubTotal) }}</span>
        </li>
        <li class="cart-summary__item">
          <span class="cart-summary__label">{{ $t('payment.delivery_cost') }}</span>
          <span class="cart-summary__value">{{ formattedPrice(cart.activeDeliveryOptionCost) }}</span>
        </li>
        <li class="cart-summary__item cart-summary__item--total">
          <span class="cart-summary__label">{{ $t('payment.total') }}</span>
          <span class="cart-summary__value">{{ formattedPrice(cartTotalCost) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import Helpers from "@/util/helpers"
export default {
  name: "cart-total",
  mixins: [Helpers],
  computed: {
    ...mapState(['cart']),
    ...mapGetters(['cartTotalCost'])
  }
}
</script>